import { SxStyleProp } from 'theme-ui';

export const FilterContainer: SxStyleProp = {
  alignItems: 'center',
  justifyContent: 'center',
  '> div': {
    marginX: [null, '15px'],
    marginY: ['7px', 'unset'],
    '&:first-of-type': {
      marginLeft: [null, '0'],
      marginTop: 'unset',
    },
    '&:last-of-type': {
      marginRight: [null, '0'],
      marginBottom: 'unset',
    },
  },
  flexDirection: ['column', 'row'],
};

export const SearchBox: SxStyleProp = {
  position: 'relative',
  marginTop: ['18px', 'unset'],
};

export const SearchInput: SxStyleProp = {
  backgroundColor: '#F2F2F2',
  borderRadius: '8px',
  border: 0,
  width: ['307px', null, '472px'],
  variant: 'text.dropdown',
  color: 'grayDark.100',
  paddingY: '4px',
  paddingLeft: '15px',
  paddingRight: '40px',
  '&:placeholder': {
    color: 'grayDark.100',
  },
};

export const SearchIcon: SxStyleProp = {
  position: 'absolute',
  right: '16px',
  top: '50%',
  transform: 'translateY(-50%)',
  '> svg': {
    width: '20px',
    height: '20px',
    path: {
      stroke: 'grayDark.100',
    },
  },
};
